import { createActor } from 'xstate';
import { studyPhaseMachine } from './studyPhaseMachine';
import { store } from '../store/store';
import { setStudyPhase, StudyPhase } from '../slices/study/studySlice';

export const studyPhaseNavigator = createActor(studyPhaseMachine, {
  inspect:
    process.env.NODE_ENV !== 'production'
      ? {
          // This will log all events, state changes, and context updates in development
          next: (inspectionEvent) => {
            if (inspectionEvent.type === '@xstate.event') {
              console.log('🎯 Event:', inspectionEvent.event);
            } else if (inspectionEvent.type === '@xstate.snapshot') {
              console.log('📊 State change:', {
                from:
                  'value' in inspectionEvent.snapshot
                    ? inspectionEvent.snapshot.value
                    : 'unknown',
                context:
                  'context' in inspectionEvent.snapshot
                    ? inspectionEvent.snapshot.context
                    : {},
              });
            }
          },
        }
      : undefined,
});

// Navigation function that can be set from React components
let navigate: ((path: string) => void) | null = null;

export const setNavigateFunction = (
  navigateFunction: (path: string) => void
) => {
  navigate = navigateFunction;
};

// Route mapping using enum values
const stateToRouteMap: Record<StudyPhase, string> = {
  [StudyPhase.LOADING_HOME]: '/',
  [StudyPhase.HOME]: '/',
  [StudyPhase.BLOCK_SELECT]: '/study/qbank',
  [StudyPhase.LOADING_BLOCK_SELECT]: '/study/qbank',
  [StudyPhase.BLOCK_STUDY]: '/study/qbank/block',
  [StudyPhase.LOADING_BLOCK_STUDY]: '/study/qbank/block',
  [StudyPhase.BLOCK_REVIEW]: '/study/qbank/block/review',
  [StudyPhase.LOADING_BLOCK_REVIEW]: '/study/qbank/block/review',
  [StudyPhase.FLASHCARD_STUDY]: '/study/flashcards',
  [StudyPhase.LOADING_FLASHCARD_STUDY]: '/study/flashcards',
  [StudyPhase.SESSION_SUMMARY]: '/study/summary',
  [StudyPhase.LOADING_SESSION_SUMMARY]: '/study/summary',
  [StudyPhase.LOADING_PAST_BLOCKS]: '/past-blocks',
  [StudyPhase.PAST_BLOCKS]: '/past-blocks',
  [StudyPhase.VIDEO_STUDY]: '/study/video',
  [StudyPhase.LOADING_VIDEO_STUDY]: '/study/video',
};

// Single place to mirror the actor state -> Redux and handle navigation
studyPhaseNavigator.subscribe((snapshot) => {
  const currentState = snapshot.value as StudyPhase;

  // Update Redux state
  store.dispatch(setStudyPhase(currentState));

  // Navigate only for non-loading states
  const targetRoute = stateToRouteMap[currentState];
  if (navigate && targetRoute) {
    navigate(targetRoute);
  }
});

studyPhaseNavigator.start();
